import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    claimAffiliateOrder,
    fetchAffiliateOrders,
    requestAffiliatePayout,
    submitAffiliateOrder,
    updateAffiliateOrder
} from "./affiliateOrdersApi";

//Async thunk
export const fetchAffiliateOrdersThunk = createAsyncThunk(
    "affilicateOrders/fetchAll",
    async (payload, { rejectWithValue, signal }) => {
        try {
            const res = await fetchAffiliateOrders(payload, signal);
            return res;
        } catch (error) {
            return rejectWithValue(error.message || "Failed to fetch orders");
        }
    }
);

export const claimAffiliateOrderThunk = createAsyncThunk(
    "affiliateOrders/claim",
    async ({ orderId, sellerId }, { rejectWithValue }) => {
        try {
            const res = await claimAffiliateOrder(orderId, sellerId);
            return res;
        } catch (error) {
            return rejectWithValue(error.message || "Failed to claim order");
        }
    }
);

export const submitAffiliateOrderThunk = createAsyncThunk(
    "affiliateOrders/submit",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await submitAffiliateOrder(payload);
            return res;
        } catch (error) {
            return rejectWithValue(error.message || "Failed to submit order");
        }
    }
);

export const updateAffiliateOrderThunk = createAsyncThunk(
    "affiliateOrders/update",
    async ({ id, payload }, { rejectWithValue }) => {
        try {
            const res = await updateAffiliateOrder({ id, payload });
            return res;
        } catch (error) {
            return rejectWithValue(error.message || "Failed to update order properties");
        }
    }
);
